import { Reveal, SectionHeading } from "./Reveal";
import { Globe2, PhoneOff, Rocket } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    icon: Globe2,
    title: "Instant local footprint",
    body: "Your Google Business Profile already holds your story — reviews, photos, hours, services. Our AI reads it and builds a conversion-ready website in hours, not months.",
    span: "md:col-span-5",
  },
  {
    num: "02",
    icon: PhoneOff,
    title: "Zero missed calls, ever",
    body: "62% of calls to local businesses go unanswered. Every missed call is revenue walking to your competitor. Our voice agent picks up on the first ring — nights, weekends, holidays.",
    span: "md:col-span-7",
    featured: true,
  },
  {
    num: "03",
    icon: Rocket,
    title: "An autonomous revenue machine",
    body: "Site converts visitors. Voice agent converts callers. Confirmations, reminders, and follow-ups fire automatically. You wake up to a booked calendar.",
    span: "md:col-span-12",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-24 md:py-36 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          testId="manifesto-heading"
          kicker="The Manifesto"
          title="Local businesses deserve enterprise-grade AI"
          sub="Three beliefs drive everything we build at TalkLogical."
        />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-6">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.12} className={c.span}>
              <div
                data-testid={`manifesto-card-${c.num}`}
                className={`glow-card group relative h-full rounded-2xl p-8 md:p-10 overflow-hidden ${
                  c.featured ? "border-cyan-400/25" : ""
                }`}
              >
                {c.featured && (
                  <div className="absolute -top-24 -right-24 h-56 w-56 rounded-full bg-cyan-400/10 blur-3xl group-hover:bg-cyan-400/20 transition-colors duration-700" />
                )}
                <div className="flex items-start justify-between">
                  <span className="font-mono text-sm font-semibold tracking-[0.3em] text-cyan-400/80">
                    {c.num}
                  </span>
                  <c.icon className="h-6 w-6 text-slate-500 group-hover:text-cyan-300 transition-colors duration-500" />
                </div>
                <h3 className="mt-8 font-display text-xl sm:text-2xl font-semibold tracking-tight text-slate-50">
                  {c.title}
                </h3>
                <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed max-w-2xl">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
